import React, { useState, useEffect } from 'react';
import ModalPortal from 'components/Modal';
import { ModalBorrarTarjeta } from 'pages/Credito/7-Modals'
import Styles from './styles.module.sass'
import { removeStorage } from 'functions/storageBase64'
import { getCardStatus } from 'services/Cards'
import { dataLayerButtons } from 'functions/dataLayerFunction'
import { ROUTE_PAGOS_EXPRESS, SUB_DIRECTORY } from 'constants/general';


export function RemoveCardSears(props){
    const {
        dataSaldos,
        setUdCard
    } = props

    const [showModalBorrarTarjeta, SetShowModalBorrarTarjeta] = useState(false);
    const [borrar, setBorrarT] = useState(false);
    const seccionPortal = window.location.pathname.replace(`/${SUB_DIRECTORY}`, '') || '/'
    const routePagosExpress = ROUTE_PAGOS_EXPRESS
    const ifRoute = routePagosExpress?.find(item => item === seccionPortal )

    // cerrar modal de tarjeta duplicada
    const handleClose = () => SetShowModalBorrarTarjeta(false);

    // realiza encendio / apagado de la tarjeta
    const [responseActive, setResponseActive] = useState()
    const handleBorrar = () => {
        SetShowModalBorrarTarjeta(true);
    };
    // no deseo  apagar la tarjeta (modal)
    const noRemove = () => {
        SetShowModalBorrarTarjeta(false);
        setBorrarT(true)
    };
    
    // si deseo  apagar la tarjeta (modal)
    const siRemove = () => {
        SetShowModalBorrarTarjeta(false);
        getCardStatus({dataCard:{cardending: dataSaldos?.cardending, no_internet: dataSaldos?.noInternet, active: 2 }})
        .then(setResponseActive)
        setBorrarT(false)
    };

    useEffect(()=>{
        if(responseActive){
            dataLayerButtons({eventName: " credito_eliminartarjeta"})
            removeStorage('lastConsultData')
            removeStorage('sears_numero_internet')
            removeStorage('cardending')
            setUdCard(true)
            setTimeout(function(){
                window.location.reload()
            },700)
        }
    },[responseActive])

    return(
        !ifRoute 
            ? 
                <>
                    <div onClick={handleBorrar} className={Styles?.btnEliminar}>Eliminar</div>
                    {showModalBorrarTarjeta &&
                        <ModalPortal type="modalSB" onClose={handleClose} >
                            <ModalBorrarTarjeta remvoeAction={siRemove} awaitAction={noRemove}
                                title="Eliminar tarjeta"
                                body={`La tarjeta con terminacion ${dataSaldos?.cardending} sera eliminada de tu cuenta`}
                                subBody="¿Deseas Eliminar definitivamente?" />
                        </ModalPortal>
                    }
                </>
            : null
    )
}